(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tm-expression-panel-photos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const zoom=event.target.closest('[data-tm-panel-zoom]');
 if(zoom){event.preventDefault();const dialog=zoom.closest('.tm-hc-step').querySelector('.tm-panel-dialog');const image=dialog.querySelector('img');image.src=zoom.dataset.tmPanelZoom;image.alt=zoom.dataset.tmPanelCaption+' — full mailbox photo';dialog.querySelector('p').textContent=zoom.dataset.tmPanelCaption;dialog.showModal();return;}
 const close=event.target.closest('.tm-panel-dialog__close');
 if(close)close.closest('dialog').close();
 if(event.target.matches('.tm-panel-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tm-expressions-mailbox-photos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('[data-tm-expression-value]');
 if(!button)return;
 const input=[...button.closest('fieldset').querySelectorAll('input[data-option-position]')].find(input=>input.value===button.dataset.tmExpressionValue);
 if(input&&!input.checked)input.click();
});
  } catch(e) { console.error(e); }
})();

})();
